exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-bar[data-v-ec51d416]{padding-bottom:1rem}.top-bar[data-v-ec51d416]{align-items:center;justify-content:space-between;padding-bottom:1rem;color:#504e4e}.title[data-v-ec51d416]{font-size:14px;font-weight:600}[data-v-ec51d416] .van-grid-item__content{padding:4px;background-color:#f2f2f2;border:1px solid #dedede}[data-v-ec51d416] .van-grid-item__text{font-family:PingFangSC-Regular;font-size:12px;color:#7d7d7d}.active[data-v-ec51d416] .van-grid-item__text{color:#f15907}.active[data-v-ec51d416] .van-grid-item__content{background-color:#f4e5e5;border:1px solid #f15907}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ec51d416","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/SearchTypeItem.vue
// module id = 876
// module chunks = 0